var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 33,
    viewBox: "0 0 111 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88.039,
    height: 25.6,
    rx: 8,
    transform: "matrix(1.25 0 0 -1.25 0.451172 32.5)",
    fill: "#111827"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1109 9.70595C41.1109 10.2914 40.9326 10.7603 40.5812 11.11C40.1772 11.5246 39.651 11.7332 39.0062 11.7332C38.3899 11.7332 37.8637 11.5211 37.4321 11.103C36.9995 10.6788 36.7837 10.1582 36.7837 9.53504C36.7837 8.91189 36.9995 8.39128 37.4321 7.97059C37.8637 7.54901 38.3899 7.33691 39.0062 7.33691C39.313 7.33691 39.6055 7.39914 39.8846 7.51483C40.1629 7.6314 40.3894 7.78916 40.5535 7.98373L40.1807 8.35359C39.8945 8.02142 39.5047 7.85752 39.0062 7.85752C38.5567 7.85752 38.1669 8.01178 37.8361 8.32292C37.5088 8.63493 37.3447 9.03898 37.3447 9.53504C37.3447 10.0311 37.5088 10.4387 37.8361 10.7507C38.1669 11.0583 38.5567 11.2161 39.0062 11.2161C39.4833 11.2161 39.8846 11.0583 40.2012 10.7472C40.4099 10.5412 40.5286 10.2572 40.5598 9.89439H39.0062V9.3878H41.0788C41.1038 9.49736 41.1109 9.60341 41.1109 9.70595Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3992 7.94955H42.4523V9.28175H44.2074V9.78833H42.4523V11.1205H44.3992V11.6368H41.9011V7.43332H44.3992V7.94955Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7197 11.6368H46.1686V7.94955H44.9744V7.43332H47.9148V7.94955H46.7197V11.6368Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0428 11.6368V7.43332H50.593V11.6368H50.0428Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0322 11.6368H52.4855V7.94955H51.2869V7.43332H54.2309V7.94955H53.0322V11.6368Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7978 11.096C59.3759 11.5211 58.8533 11.7332 58.2299 11.7332C57.603 11.7332 57.0803 11.5211 56.6585 11.096C56.2375 10.6718 56.028 10.1512 56.028 9.53504C56.028 8.9189 56.2375 8.39829 56.6585 7.97409C57.0803 7.54901 57.603 7.33691 58.2299 7.33691C58.8498 7.33691 59.3724 7.54901 59.7942 7.9776C60.2187 8.4053 60.4283 8.92241 60.4283 9.53504C60.4283 10.1512 60.2187 10.6718 59.7978 11.096ZM57.0661 10.7437C57.3836 11.0583 57.7697 11.2161 58.2299 11.2161C58.6865 11.2161 59.0763 11.0583 59.3902 10.7437C59.7068 10.429 59.8674 10.025 59.8674 9.53504C59.8674 9.04511 59.7068 8.64107 59.3902 8.32642C59.0763 8.01178 58.6865 7.85402 58.2299 7.85402C57.7697 7.85402 57.3836 8.01178 57.0661 8.32642C56.7495 8.64107 56.5889 9.04511 56.5889 9.53504C56.5889 10.025 56.7495 10.429 57.0661 10.7437Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2015 11.6368V7.43332H61.8704L63.9502 10.7025H63.9743L63.9502 9.89438V7.43332H64.5005V11.6368H63.9261L61.7482 8.20635H61.7242L61.7482 9.01794V11.6368H61.2015Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8927 17.7752C54.2169 17.7752 52.8479 19.0285 52.8479 20.7578C52.8479 22.473 54.2169 23.7394 55.8927 23.7394C57.572 23.7394 58.941 22.473 58.941 20.7578C58.941 19.0285 57.572 17.7752 55.8927 17.7752ZM55.8927 22.565C54.9732 22.565 54.1821 21.8191 54.1821 20.7578C54.1821 19.6824 54.9732 18.9497 55.8927 18.9497C56.8122 18.9497 57.6068 19.6824 57.6068 20.7578C57.6068 21.8191 56.8122 22.565 55.8927 22.565ZM49.2493 17.7752C47.57 17.7752 46.2046 19.0285 46.2046 20.7578C46.2046 22.473 47.57 23.7394 49.2493 23.7394C50.9278 23.7394 52.2941 22.473 52.2941 20.7578C52.2941 19.0285 50.9278 17.7752 49.2493 17.7752ZM49.2493 22.565C48.3289 22.565 47.5352 21.8191 47.5352 20.7578C47.5352 19.6824 48.3289 18.9497 49.2493 18.9497C50.1688 18.9497 50.9599 19.6824 50.9599 20.7578C50.9599 21.8191 50.1688 22.565 49.2493 22.565ZM41.344 18.6894V19.9567H44.4235C44.3335 20.6649 44.0927 21.1855 43.7235 21.5483C43.274 21.9866 42.5739 22.473 41.344 22.473C39.4488 22.473 37.9648 20.9699 37.9648 19.1074C37.9648 17.245 39.4488 15.7419 41.344 15.7419C42.3687 15.7419 43.1143 16.1354 43.6646 16.6455L44.5734 15.7524C43.8037 15.0302 42.7799 14.4754 41.344 14.4754C38.7452 14.4754 36.561 16.5535 36.561 19.1074C36.561 21.6614 38.7452 23.7394 41.344 23.7394C42.7487 23.7394 43.8037 23.2872 44.6331 22.4388C45.4831 21.6035 45.7479 20.4291 45.7479 19.4808C45.7479 19.1863 45.723 18.9155 45.6784 18.6894H41.344ZM73.6699 19.6719C73.4193 19.0049 72.646 17.7752 71.071 17.7752C69.5103 17.7752 68.2109 18.9838 68.2109 20.7578C68.2109 22.4283 69.4969 23.7394 71.2209 23.7394C72.6148 23.7394 73.4193 22.9042 73.7501 22.4178L72.7156 21.7403C72.3704 22.2363 71.9004 22.565 71.2209 22.565C70.5457 22.565 70.0614 22.2609 69.7511 21.6614L73.8099 20.011L73.6699 19.6719ZM69.5317 20.6649C69.4969 19.515 70.4405 18.926 71.1165 18.926C71.6463 18.926 72.0958 19.1863 72.2456 19.5588L69.5317 20.6649ZM66.2328 23.558H67.567V14.7935H66.2328V23.558ZM64.0477 18.4396H64.0031C63.7035 18.0907 63.1318 17.7752 62.4076 17.7752C60.8879 17.7752 59.4984 19.0864 59.4984 20.7674C59.4984 22.4388 60.8879 23.7394 62.4076 23.7394C63.1318 23.7394 63.7035 23.4213 64.0031 23.062H64.0477V23.4897C64.0477 24.6299 63.4279 25.2426 62.4281 25.2426C61.613 25.2426 61.1073 24.6641 60.8986 24.1777L59.7383 24.6536C60.0728 25.4441 60.9584 26.417 62.4281 26.417C63.9924 26.417 65.3124 25.5125 65.3124 23.3117V17.9566H64.0477V18.4396ZM62.5218 22.565C61.6023 22.565 60.8326 21.8086 60.8326 20.7674C60.8326 19.7166 61.6023 18.9497 62.5218 18.9497C63.4279 18.9497 64.1423 19.7166 64.1423 20.7674C64.1423 21.8086 63.4279 22.565 62.5218 22.565ZM79.9164 14.7935H76.7253V23.558H78.056V20.2372H79.9164C81.3941 20.2372 82.8434 19.1863 82.8434 17.5149C82.8434 15.8444 81.3906 14.7935 79.9164 14.7935ZM79.9511 19.018H78.056V16.0127H79.9511C80.9447 16.0127 81.5119 16.8234 81.5119 17.5149C81.5119 18.1933 80.9447 19.018 79.9511 19.018ZM88.1766 17.7586C87.2152 17.7586 86.2155 18.1758 85.8043 19.1004L86.9851 19.5868C87.2393 19.1004 87.7066 18.9426 88.2007 18.9426C88.891 18.9426 89.5911 19.3502 89.6018 20.0698V20.1618C89.361 20.0251 88.8455 19.8226 88.2114 19.8226C86.9396 19.8226 85.6438 20.5106 85.6438 21.7946C85.6438 22.969 86.6855 23.7254 87.8565 23.7254C88.7519 23.7254 89.246 23.3284 89.5563 22.8665H89.6018V23.544H90.887V20.1819C90.887 18.628 89.7061 17.7586 88.1766 17.7586ZM88.0161 22.5615C87.5809 22.5615 86.9744 22.3494 86.9744 21.8191C86.9744 21.1408 87.7307 20.8805 88.3853 20.8805C88.9713 20.8805 89.246 21.0076 89.6018 21.175C89.4975 21.9865 88.7867 22.5615 88.0161 22.5615ZM95.5691 17.9505L94.0396 21.7499H93.9941L92.4129 17.9505H90.9779L93.3538 23.26L91.9982 26.2145H93.3886L97.0496 17.9505H95.5691ZM83.5747 23.558H84.9089V14.7935H83.5747V23.558Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2322 7.80951C14.0227 8.02512 13.9014 8.36079 13.9014 8.79551V24.3016C13.9014 24.7363 14.0227 25.072 14.2322 25.2876L14.284 25.335L23.1257 16.6494V16.4443L14.284 7.75868L14.2322 7.80951Z",
    fill: "url(#paint0_linear_344_12939)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0695 19.5459L23.1255 16.6492V16.4441L26.073 13.5475L26.139 13.5852L29.6297 15.537C30.6259 16.0909 30.6259 17.0024 29.6297 17.5599L26.139 19.5082L26.0695 19.5459Z",
    fill: "url(#paint1_linear_344_12939)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.139 19.5082L23.1254 16.5467L14.2319 25.2875C14.5628 25.6294 15.1024 25.6706 15.716 25.3287L26.139 19.5082Z",
    fill: "url(#paint2_linear_344_12939)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.139 13.5854L15.716 7.76487C15.1024 7.42656 14.5628 7.46775 14.2319 7.80957L23.1254 16.5469L26.139 13.5854Z",
    fill: "url(#paint3_linear_344_12939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_12939",
    x1: 22.3407,
    y1: 24.4631,
    x2: 10.5754,
    y2: 12.4911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_344_12939",
    x1: 30.9269,
    y1: 16.5457,
    x2: 13.663,
    y2: 16.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_344_12939",
    x1: 24.5003,
    y1: 14.9368,
    x2: 8.54555,
    y2: -1.29826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_344_12939",
    x1: 11.9933,
    y1: 30.4465,
    x2: 19.1178,
    y2: 23.1969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.b3e7728514c6e187724ce7fc8d572201.svg";
export { ForwardRef as ReactComponent };